var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-button',_vm._g({class:("table-control table-control--" + _vm.type),attrs:{"type":"text","disabled":_vm.disabled}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }